import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Award, TrendingUp, AlertCircle, Bell } from 'lucide-react'

const BADGE_LABELS = {
    streak_3: 'On Fire 3',
    streak_7: 'Week Warrior',
    streak_30: 'Unstoppable',
    checklist_king: 'Checklist King',
    level_up: 'Level Up!'
}

export default function AchievementToast({ type, title: customTitle, message, onClick, onDismiss, duration = 4000 }) {
    const { t } = useTranslation()
    const [visible, setVisible] = useState(true)

    useEffect(() => {
        const t = setTimeout(() => {
            setVisible(false)
            setTimeout(onDismiss, 300)
        }, duration)
        return () => clearTimeout(t)
    }, [duration, onDismiss])

    const handleClick = () => {
        if (!onClick) return
        onClick()
        setVisible(false)
        setTimeout(onDismiss, 180)
    }

    const label = type === 'badge' ? BADGE_LABELS[message] || message : message
    const icon = type === 'error' ? <AlertCircle size={20} /> : type === 'levelUp' ? <TrendingUp size={20} /> : type === 'notification' ? <Bell size={20} /> : <Award size={20} />
    const title = customTitle || (type === 'error'
        ? t('common.error')
        : type === 'levelUp'
            ? t('achievement.levelUp')
            : type === 'notification'
                ? t('activity.notificationFallback')
                : t('achievement.defaultTitle'))

    return (
        <div
            className={`achievement-toast ${type === 'error' ? 'achievement-toast-error' : ''} ${onClick ? 'achievement-toast-clickable' : ''} ${visible ? 'visible' : ''}`}
            role="alert"
            tabIndex={onClick ? 0 : undefined}
            onClick={handleClick}
            onKeyDown={(event) => {
                if (!onClick) return
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    handleClick()
                }
            }}
        >
            <div className="achievement-toast-icon">{icon}</div>
            <div className="achievement-toast-content">
                <div className="achievement-toast-title">{title}</div>
                <div className="achievement-toast-message">{label}</div>
            </div>
        </div>
    )
}
